import { calculateVitalityStatus } from './vitality-reader';

type Row = Record<string, unknown>;
const record = (value: unknown): Row | null => value !== null && typeof value === 'object' && !Array.isArray(value) ? value as Row : null;
const scalar = (value: unknown): unknown => Array.isArray(value) ? value[0] : value;

/** Settle only the held vitality cluster. The initial compiler's tier formula also owns deltas. */
export function patchVitalityCluster(row: Row, vCurrent: number): void {
  const vitality = record(record(row.computed)?.vitality);
  if (!vitality) return;
  const effectiveMax = Number(scalar(vitality.effective_v_max) ?? scalar(vitality.v_max) ?? 0);
  const temp = Number(scalar(vitality.v_temp) ?? 0);
  const total = effectiveMax + temp;
  const current = Math.max(0, Math.min(vCurrent, effectiveMax > 0 ? effectiveMax : vCurrent));
  vitality.base_v_current = vCurrent;
  vitality.v_current = current;
  vitality.v_lost = Math.max(0, effectiveMax - current);
  const pct = total > 0 ? Math.floor(current / total * 100) : 0;
  vitality.v_percent = vitality.v_bar_v_percent = pct;
  vitality.v_bar_total = total;
  vitality.v_status = calculateVitalityStatus(current, effectiveMax, temp);
  const tempPct = total > 0 ? Math.floor(temp / total * 100) : 0;
  vitality.v_temp_percent = vitality.v_bar_v_temp_percent = tempPct;
}
